import { FormEvent, useState } from 'react'
import { Link as RouterLink } from 'react-router'
import { Alert, Box, Button, Link, Paper, Stack, TextField, Typography } from '@mui/material'
import { api } from '../api/client.js'
import { HappyOpsLogo } from '../components/HappyOpsLogo.js'

/**
 * "Passwort vergessen": nimmt die E-Mail-Adresse entgegen und stößt den
 * Mail-Versand des Reset-Links an. Die Antwort ist bewusst immer gleich —
 * ob ein Account existiert, verrät der Server nicht (siehe chat-api,
 * http/auth.ts /forgot-password).
 */
export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setSubmitting(true)
    setError(undefined)
    try {
      await api.forgotPassword(email)
      setSubmitted(true)
    } catch {
      setError('Anfrage fehlgeschlagen. Bitte später erneut versuchen.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <Paper sx={{ p: 4, width: 360 }} elevation={3}>
        <Box display="flex" alignItems="center" gap={1.5} mb={3}>
          <HappyOpsLogo width={36} height={36} />
          <Typography variant="h5">Passwort vergessen</Typography>
        </Box>
        {submitted ? (
          <Stack spacing={2}>
            <Alert severity="success">
              Wenn ein Account mit dieser E-Mail-Adresse existiert, haben wir dir einen Link zum
              Zurücksetzen des Passworts geschickt.
            </Alert>
            <Link component={RouterLink} to="/login">
              Zurück zur Anmeldung
            </Link>
          </Stack>
        ) : (
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              {error && <Alert severity="error">{error}</Alert>}
              <Typography variant="body2" color="text.secondary">
                Gib deine E-Mail-Adresse ein — wir schicken dir einen Link, mit dem du ein neues
                Passwort setzen kannst.
              </Typography>
              <TextField
                label="E-Mail"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
              />
              <Button type="submit" variant="contained" disabled={submitting}>
                Link anfordern
              </Button>
              <Link component={RouterLink} to="/login">
                Zurück zur Anmeldung
              </Link>
            </Stack>
          </form>
        )}
      </Paper>
    </Box>
  )
}
